import Vue from 'vue'

export default new Vue;


// WEBPACK FOOTER //
// ./src/assets/js/eventBus.js